/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="70.08" height="95.58" viewBox="0 0 70.08 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g>
          <g>
            <path d="M97.71,62.71A1.24,1.24,0,0,1,99,64V65.3c0,.43,0,.86,0,1.29l0,1.25c0,.41,0,.81,0,1.21l-.06,1.18-.06,1.13C97.67,87,92.93,91.7,78.23,93.49l-1.07.12-.55.06-.55.06c-9.8.91-16.09,4.33-19.73,10.07-3.06,4.83-4.28,11.18-4.3,20a1.25,1.25,0,0,1-2.5,0c0-9.29,1.32-16.06,4.69-21.37,4-6.33,10.83-10.11,21-11.17l1.06-.1,1-.11,1-.12.93-.12C90.61,89.28,94.71,85.75,96,74.37l.1-.94.08-1c0-.5.07-1,.1-1.53l.06-1.06,0-.55,0-1.12,0-1.17,0-1.2,0-1.24V64A1.25,1.25,0,0,1,97.71,62.71Z" transform="translate(-42.5 -29.5)" fill="#0e497b"/>
            <path d="M96.78,60.47a1.25,1.25,0,0,1,1.75-.1l.1.1,13.63,15a1.25,1.25,0,0,1-1.76,1.78l-.09-.1-12.71-14-13,14.25a1.26,1.26,0,0,1-1.66.17L83,77.5a1.26,1.26,0,0,1-.17-1.66l.09-.1Z" transform="translate(-42.5 -29.5)" fill="#0e497b"/>
            <path d="M97.7,29.5a10.68,10.68,0,1,0,10.69,10.68A10.68,10.68,0,0,0,97.7,29.5Zm0,2.5a8.18,8.18,0,1,1-8.18,8.18A8.19,8.19,0,0,1,97.7,32Z" transform="translate(-42.5 -29.5)" fill="#ffb81c"/>
            <path d="M61.73,59.47a1.25,1.25,0,0,1,1.86,1.67l-.09.1L44.63,80.11a1.25,1.25,0,0,1-1.85-1.67l.09-.1Z" transform="translate(-42.5 -29.5)" fill="#ffb81c"/>
            <path d="M42.87,59.47a1.25,1.25,0,0,1,1.66-.09l.1.09L63.5,78.34a1.25,1.25,0,0,1,0,1.77,1.27,1.27,0,0,1-1.67.09l-.1-.09L42.87,61.24A1.25,1.25,0,0,1,42.87,59.47Z" transform="translate(-42.5 -29.5)" fill="#ffb81c"/>
            <path d="M106.25,104a1.25,1.25,0,0,1,1.77,0,1.27,1.27,0,0,1,.09,1.67l-.09.1L89.15,124.59a1.24,1.24,0,0,1-1.85-1.66l.09-.1Z" transform="translate(-42.5 -29.5)" fill="#ffb81c"/>
            <path d="M87.39,104a1.25,1.25,0,0,1,1.66-.09l.1.09L108,122.83a1.24,1.24,0,0,1,0,1.76,1.26,1.26,0,0,1-1.67.1l-.1-.1L87.39,105.73A1.25,1.25,0,0,1,87.39,104Z" transform="translate(-42.5 -29.5)" fill="#ffb81c"/>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'CurvedArrowThroughXxoIcon';

export default Icon;
